import React, { useState, useRef, useEffect } from 'react';
import jsQR from 'jsqr';

type QRData = {
  iccid: string;
  qrContent: string;
};

type QRImageUploaderProps = {
  onDataChange: (data: QRData[]) => void;
  disabled: boolean;
};

const QRImageUploader: React.FC<QRImageUploaderProps> = ({
  disabled,
  onDataChange,
}) => {
  const [qrDataList, setQrDataList] = useState<QRData[]>([]);
  const inputRef = useRef<HTMLInputElement>(null);
  const onDataChangeRef = useRef(onDataChange);

  useEffect(() => {
    onDataChangeRef.current = onDataChange;
  }, [onDataChange]);

  useEffect(() => {
    onDataChangeRef.current(qrDataList);
  }, [qrDataList]);

  const handleFiles = async (files: FileList) => {
    Array.from(files).forEach((file) => {
      const fileNameWithoutExtension = file.name.replace(/\.[^/.]+$/, '');
      const img = new Image();
      const reader = new FileReader();

      reader.onload = (e) => {
        if (!e.target?.result) return;

        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext('2d');
          if (!ctx) return;

          ctx.drawImage(img, 0, 0);
          const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);

          const qrCode = jsQR(imageData.data, canvas.width, canvas.height);

          if (qrCode) {
            const newEntry = {
              iccid: fileNameWithoutExtension,
              qrContent: qrCode.data,
            };
            setQrDataList((prev) => [...prev, newEntry]);
          } else {
            alert(`No se encontró ningún QR en la imagen: ${file.name}`);
          }
        };

        img.src = e.target.result as string;
      };

      reader.readAsDataURL(file);
    });
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files) {
      handleFiles(files);
    }
  };

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    const files = e.dataTransfer.files;
    if (files) {
      handleFiles(files);
    }
  };

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
  };

  const handleClick = () => {
    inputRef.current?.click();
  };

  return (
    <>
      <div
        className="border border-dashed border-gray-500 d-flex justify-content-center text-center flex-column p-8 mb-4 h-250px"
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        onClick={handleClick}
        style={{ cursor: 'pointer' }}
      >
        <input
          type="file"
          accept=".png, .jpg, .jpeg"
          onChange={handleFileChange}
          ref={inputRef}
          style={{ display: 'none' }}
          multiple
          disabled={disabled}
        />
        <a className="text-gray-800 text-hover-primary d-flex flex-column">
          <div className="symbol symbol-75px mb-6">
            <img src="/media/svg/files/image.svg" alt="Subir Imagenes" />
          </div>
          <div className="fs-5 fw-bolder mb-2">
            {qrDataList.length
              ? 'Archivo cargado'
              : 'Arrastre y suelte sus archivos aquí o seleccione un archivo'}
          </div>
        </a>
        <div className="fs-7 fw-bold text-gray-500 mt-auto">
          Tamaño máximo de archivo: 15 MB
        </div>
      </div>

      {/* <div>
        <h5>Resultados:</h5>
        {qrDataList.length === 0 && <p>No hay QR decodificados aún.</p>}
        {qrDataList.map((item, index) => (
          <div key={index} className="border p-3 mb-2 rounded">
            <p>
              <strong>ICCID (nombre archivo):</strong> {item.iccid}
            </p>
            <p>
              <strong>Contenido QR:</strong> {item.qrContent}
            </p>
          </div>
        ))}
      </div> */}
    </>
  );
};
export { QRImageUploader };
